import {
  DEFAULT_JUDGE0_LANGUAGE,
  findLanguageByAlias,
  JUDGE0_LANGUAGES,
} from "./judge0Languages";

const LANG_ALIASES: Record<string, string> = {
  "c++": "cpp",
  cplusplus: "cpp",
  js: "javascript",
  node: "javascript",
  py: "python",
};

/** Restrict editor languages to the configured programming language when set. */
export function resolveProgrammingLanguages(programmingLanguage?: string) {
  const raw = String(programmingLanguage || "").toLowerCase().trim();
  if (!raw) return JUDGE0_LANGUAGES;
  const normalized = LANG_ALIASES[raw] ?? raw;
  const match = findLanguageByAlias(normalized);
  return match ? [match] : JUDGE0_LANGUAGES;
}

export function getDefaultProgrammingLanguage(programmingLanguage?: string) {
  return resolveProgrammingLanguages(programmingLanguage)[0] ?? DEFAULT_JUDGE0_LANGUAGE;
}

export function normalizeLanguageKey(programmingLanguage?: string): string | null {
  const raw = String(programmingLanguage || "").toLowerCase().trim();
  if (!raw) return null;
  const normalized = LANG_ALIASES[raw] ?? raw;
  const match = findLanguageByAlias(normalized);
  return match?.key ?? null;
}

export function getLanguageDisplayName(languageKey: string): string {
  const match = findLanguageByAlias(languageKey);
  if (match) return match.name.split("(")[0].trim();
  return languageKey.charAt(0).toUpperCase() + languageKey.slice(1);
}
